// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"410affc0","237":"4447bb50","800":"0659906a"}[chunkId] + ".chunk.css";
};